<template>
    <nav>
        <v-toolbar
            flat
            class="d-none"
            height="32px"
        >
            <v-tooltip
                :bottom="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md"
                :right="$vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
            >
                <template v-slot:activator="{ on }">
                    <v-icon
                        class="d-block pa-1"
                        data-testid="settings-icon"
                        dense
                        color="accent"
                        v-on="on"
                        @click="showBlockSettings()"
                    >
                        mdi-cog
                    </v-icon>
                </template>
                <span>{{ $t('settingsBlock') }}</span>
            </v-tooltip>
        </v-toolbar>
        <div class="content-block pa-12 text-center survey-end-screen"
            :class="!mobile() ? 'rounded-xxl' : ''" 
            :style="`background-color:` + color"  >
            <div>
              <v-row
                  align="center"
                  justify="center"
                  no-gutters
                >
                  <v-col cols="12">
                    <editor-survey
                      ref="editTitle"
                      data-testid="title-editor"
                      :content="title"
                      part="title"
                      screen="end"
                      @proceedClick="setEditor"
                      @updateSurvey="updateSurveyTitle"
                      @proceedMark="showHideEditorTextOptions"
                      @enableEditMode="enableEditMode"
                      class="end-screen-title text-h5 font-weight-bold"
                    />
                    <div
                      v-if="errorTitle"
                        class="error--text text-caption text-left"
                      >
                      {{ $t('fieldErrorRequired', { 'field': $t('labelTitle') }) }}
                    </div>
                  </v-col>
                  <v-col cols="12" class="mt-3">
                    <editor-survey
                      ref="editDescription"
                      data-testid="description-editor"
                      :content="description"
                      part="description"
                      screen="end"
                      @proceedClick="setEditor"
                      @updateSurvey="updateSurveyDescription"
                      @proceedMark="showHideEditorTextOptions"
                      @enableEditMode="enableEditMode"
                      class="end-screen-description text-subtitle-2 font-weight-regular greytext--text"
                    />
                    </v-col>
                    <v-col cols="12" class="mt-5 mb-3">
                        <editor-survey
                            ref="editImage"
                            class="survey-question-image-editor"
                            data-testid="image-editor"
                            :content='imageDisplay != null ? `<img src="`+imageDisplay+`" path="`+image+`">` : `<img src="/assets/editor_images/artboard2.png">`'
                            type="end"
                            part="image"
                            @proceedClick="setEditor"
                            @updateSurvey="updateSurveyImage"
                            @proceedMark="showHideEditorTextOptions"
                            @enableEditMode="enableEditMode"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" align="center" justify="center">
                        <v-btn
                            data-testid="end-button"
                            type="submit"
                            color="accent"
                            min-width="260"
                            dark
                            elevation="0"
                            class="rounded-xxl text-none px-4 white--text disable-events"
                        >
                            {{ $t('surveySubmit') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </nav>
</template>
<script>
import EditorSurvey from '../../EditorSurvey';
import { repeatedMethodsMixin } from '../../../mixins/repeatedMethodsMixin'

export default {
    props: {
        anonymous: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        imageDisplay: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: '#FFFFFF'
        }
    },
    components: {
        EditorSurvey
    },

    mixins: [repeatedMethodsMixin],

    data(){
        return{
            name: localStorage.user ? JSON.parse(localStorage.user).first_name + " " + JSON.parse(localStorage.user).last_name : '',
            errorTitle: false
        }
    },
    created() {
        if(this.strip(this.title).trim() == ''){
            this.errorTitle = true
        }else{
            this.errorTitle = false
        }
    },

    methods: {
        resetEditor(){
            this.$emit('resetEditor')
        },
        setEditor(editor){
            this.$emit('setEditor', editor)
        },
        updateSurveyTitle(index, content){
            this.$emit('updateEndTitle', content)
            if(this.strip(content).trim() == ''){
                this.errorTitle = true
            }else{
                this.errorTitle = false
            }
        },
        updateSurveyDescription(index, content){
            this.$emit('updateEndDescription', content)
        },
        updateSurveyImage(type, index, answerIndex, content){
            this.$emit('updateSurveyImage', type, index, answerIndex, content)
        },
        showHideEditorTextOptions(val){
            this.$emit('showHideEditorTextOptions', val)
        },
        enableEditMode(){
            this.$emit('enableEditMode')
        },
        showBlockSettings(){
            this.$emit('showBlockSettings')
        }
    }
}
</script>